
define('template!sdsAuthenticationChangepasswordDialog',['directive!sdcClosableSection','directive!sdsAuthenticationChangepassword'],function(template){return '<md-dialog sdc-closable-section="$close()">\r\n\t<sds-authentication-changepassword></sds-authentication-changepassword>\r\n</md-dialog>';});

